import { css, createGlobalStyle } from 'styled-components';
import { ifProp } from 'styled-tools';
// import normalizeCSS from '!raw-loader!normalize.css'
import colors from './colors';

// --- UPDATES TO GLOBAL STYLES REQUIRES A PAGE REFRESH ---

// expand normalize.css string into css

/* ${normalizeCSS} */
export const normalize = css`
  body {
    background-color: ${ifProp('bgWhite', colors.white, colors.blue)};
    max-width: 100vw;
  }

  // fixes for blog/agile-product-development
  table.mobile-fix {
    td {
      padding-right: 0;
    }
    td:not(:first-child) {
      padding-left: 0.9rem;
    }
  }

  iframe.mobile-fix {
    max-width: 92vw;
  }
`;
// create a global page style
export const GlobalStyle = createGlobalStyle`
  ${normalize}
`;
